module.exports = __webpack_public_path__ + "assets/img/img329.57e31be8.png";